/**
 * Coach Store - Global state for the AI coach sidebar
 * Manages the open/closed state of the coach panel
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CoachStore {
  isCoachOpen: boolean
  setIsCoachOpen: (open: boolean) => void
  toggleCoach: () => void
}

export const useCoachStore = create<CoachStore>()(
  persist(
    (set) => ({
      isCoachOpen: false,
      setIsCoachOpen: (open) => set({ isCoachOpen: open }),
      toggleCoach: () => set((state) => ({ isCoachOpen: !state.isCoachOpen }))
    }),
    {
      name: 'coach-store',
      partialize: (state) => ({ isCoachOpen: state.isCoachOpen }) // Only persist open state
    }
  )
)